import styled from "styled-components";
import { colors, fonts } from "./variables.js";

export const P1 = styled.p`
	font-size: 1.2rem;
	font-family: ${props => (props.mainFont ? fonts.main : fonts.default)};
	line-height: 1.6;
	color: ${props => (props.dark ? colors.primary1 : colors.primary3)};
	text-align: ${props => (props.center ? "center" : "left")};
`;

export const P2 = styled.p`
	font-size: 1rem;
	font-family: ${props => (props.mainFont ? fonts.main : fonts.default)};
	line-height: 1.6;
	color: ${props => (props.dark ? colors.primary1 : colors.primary3)};
	text-align: ${props => (props.center ? "center" : "left")};
`;

export const P3 = styled.p`
	font-size: 0.85rem;
	font-family: ${props => (props.mainFont ? fonts.main : fonts.default)};
	line-height: 1.5;
	color: ${props => (props.dark ? colors.primary1 : colors.primary3)};
	text-align: ${props => (props.center ? "center" : "left")};
`;
